// Node modules
import { IEvent } from "@quest/base-core"
import { PlayerMsgController } from "@quest/murka-games-behavior-leopard/dist"

export class PlayerMsgControllerGame extends PlayerMsgController {


    /**
     * Method overrided to hide player messages
     * @param evt 
     */
    protected showWinLineMessage(evt: IEvent): void {
        //  This comments is intended do not call super here.
    }

}

